import * as React from 'react'
import { noop } from 'ui/multi-product/constants'
import { isBrowser } from './trustpilotHelperScript'

const isUnsupported =
  isBrowser() &&
  (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useIsElementInView = (callback: () => void | undefined): React.RefObject<any> => {
  const ref = React.useRef()
  const callbackRef = React.useRef(noop)
  React.useEffect(() => {
    const node = ref.current

    const observer = new IntersectionObserver((entries): void => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && ref.current && callbackRef.current) {
          callbackRef.current(callback)
        }
      })
    }, options)

    if (node) {
      observer.observe(node)
    }

    return (): void => observer.disconnect()
  }, [])

  // set current callback in ref, before second useEffect uses it
  React.useEffect(() => {
    // useEffect wrapper to be safe for concurrent mode
    callbackRef.current = callback
  })

  if (typeof window === 'undefined') {
    return ref
  }

  if (isUnsupported && callbackRef.current) {
    callbackRef.current(callback)
  }

  const options = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0,
  }

  return ref
}

export default useIsElementInView
